<template>
    <BaseModal ref="baseModalRef" v-bind="childProps">
        <template #body>
            <div class="search-wrap">
                <div class="row">
                    <div class="col-md-4">
                        <div class="mb-3">
                            <ElLabel name="회사분류">
                                <template #end="{id}">
                                    <ElInput :id="id" v-model="cmpSearchParams.classNm" @inputKeyupEnter="getCmpList"/>
                                </template>
                            </ElLabel>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="mb-3">
                        <ElLabel name="회사명">
                            <template #end="{id}">
                                <ElInput :id="id" v-model="cmpSearchParams.cmp_nm" @inputKeyupEnter="getCmpList"/>
                            </template>
                        </ElLabel>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="mb-3">
                        <ElLabel name="사업자등록번호">
                            <template #end="{id}">
                                <ElInput :id="id"
                                ref="businessNoRef"
                                @update:modelValue="r=>bizNoFormat(r)"
                                @inputKeyupEnter="getCmpList"/>
                            </template>
                        </ElLabel>

                        </div>
                    </div>                      
                </div>
            </div>
            <div class="search-detail-wrap"></div>

            <div class="text-end py-2">
                <ElButton type="search" @buttonClick="getCmpList()">검색</ElButton>
            </div>


            <div class="table-responsive table-list">
                <DataTable
                    v-model:selection="gridProps.selection" 
                    v-bind="gridProps"
                    @row-dblclick="rowDbClick"
                >
                <template #empty>
                    <div class="center">데이터가 존재하지 않습니다.</div>
                </template>
                <Column
                    v-for="cmp of gridProps.cmpGridColumn"
                    :class="cmp.class"
                    :key="cmp"
                    v-bind="cmp"
                >
                </Column>
                </DataTable>
            </div>
        </template>
        
    </BaseModal>


</template>
<script setup>
import { reactive,ref,onBeforeMount } from 'vue';
import BaseModal from '@/components/common/modal/BaseModal.vue';
import { useLoading } from '@/composable/Loading.js'
import { compList, classList } from '@/api/comp';
import common from '@/js/common';
import DataTable from "primevue/datatable";
import Column from "primevue/column";

const { setIsLoading } = useLoading()
const baseModalRef = ref()
const businessNoRef = ref()

const emits = defineEmits(['return'])

const childProps = ref({
    modalId : 'cmpModal',
    modalNm : '회사조회',
    size:'xl',
    btnList : [
        {name : '선택' , classNm : 'search', function : selectData}
    ]
})

//그리드 속성값 정의
const gridProps = ref({
    value : [],
    selection : null,
    cmpGridColumn : [],
    dataKey : 'cmp_info_seq',
    paginator : true,
    selectionMode : 'single',
    rowsPerPageOptions : [10, 20, 50, 100, 200],
    rows : 10
})

//회사분류체계 리스트
const codeList = ref([])

//회사분류 체계 max 단계 체크를 위한 변수(cmpCodeLev에 맞게 그리드 컬럼 단계 생성)
const cmpCodeLev = ref(0) 

//회사 조회 파라미터
const cmpSearchParams = reactive({
    page_count : 1,
    unit_count : 100000,
    cmp_nm : '',
    business_no : '',
    classNm : '',
})


onBeforeMount(async()=>{
    await getCmpList()
})

//modal 오픈일때 조회 조건초기화 요청 작업
async function openModal(){
    try{
        cmpSearchParams.cmp_nm = ''
        cmpSearchParams.business_no = ''
        cmpSearchParams.classNm = ''
        await getCmpList()
    }catch(e){
        console.log(e)
    }finally{
        baseModalRef.value.openModal()
    }
}

function closeModal(){

    baseModalRef.value.closeModal()
}

//회사분류 조회
async function getClassList(notLoading){
  try {
    if(!notLoading) setIsLoading(true)
    const res = await classList()
    codeList.value = [...res.rtn]
  } catch (err) {
    console.error(err)
    alert('회사분류 정보를 불러오는데 실패했습니다.')
  } finally {
    if(!notLoading) setIsLoading(false)
  }
}

//사업자번호 형식 체크
const bizNoFormat = (no) => {
    cmpSearchParams.business_no = common.bizNoFormat(no);
    businessNoRef.value.input.value = cmpSearchParams.business_no
};


//회사 조회(모달그리드)
async function getCmpList(){
  try {
    setIsLoading(true)
    await getClassList(true)

    const res = await compList(cmpSearchParams)
    
    gridProps.value.cmpGridColumn = []
    gridProps.value.value = await res.rtn.filter((data)=>{
            //회사분류코드로 단계별 이름 매칭
            let codeFam = common.findUperCode(data.cl_class_id,codeList.value) || []
            if(cmpSearchParams.classNm){
                let flag = false
                codeFam.forEach((code)=>{
                    code = code.class_nm?.trim().toLowerCase()
                    if(code.indexOf(cmpSearchParams.classNm?.trim().toLowerCase()) !== -1){
                        flag = true
                    }
                })
                if(!flag) return
            }

            codeFam.forEach((item,index)=>{
                data[`class_nm${index+1}`] = item['class_nm']
            })


            if(cmpCodeLev.value <  codeFam.length) cmpCodeLev.value = codeFam.length

            return data
      
    })

    if(cmpCodeLev.value === 0){
        gridProps.value.cmpGridColumn = [
        {header : `회사분류1` , field : `class_nm1`,style:{width:'10%'}},
        {header : `회사분류2` , field : `class_nm2`,style:{width:'10%'}}
        ]
    }else{
        for(let i = 1; i<=cmpCodeLev.value; i++){
            gridProps.value.cmpGridColumn.push( {header : `회사분류${i}` , field : `class_nm${i}`,style:{width:'10%'}},)
        }
    }



    gridProps.value.cmpGridColumn = [
        ...gridProps.value.cmpGridColumn,
        {header : '회사명' , field : 'cmp_nm',class:'blank-div',style:{minWidth : '200px',maxWidth : '200px'}},
        {header : '사업부명' , field : 'cmp_dvsn_nm',class:'blank-div',style:{minWidth : '200px',maxWidth : '200px'}},
        {header : '사업자등록번호' , field : 'business_no',style:{minWidth : '150px'},class:'blank-div'}
    ]
  } catch (err) {
    console.error(err)
  } finally {
    setIsLoading(false)
  }
}


function selectData(){
    if(!gridProps.value.selection){
        alert('선택된 행이 없습니다.')
    }else{
        emits('return',gridProps.value.selection)
        gridProps.value.selection = null
    }
    closeModal()
    
}
function rowDbClick(row){
    emits('return',row.data)
    closeModal()
}

defineExpose({
    openModal
})
</script>